import { useClassName } from '@/styles/RelatedArticleSlider';
import { GenericComponentFactory } from 'base/components/GenericComponent';

const GenericComponent = GenericComponentFactory({ useClassName });

const Base = GenericComponent({ as: 'aside' });

export const RelatedArticleSlider = Base;
